import { useCallback, useState } from 'react'

import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import l10n from '../../../i18n/I18N'
import { usePost } from '../../../../hooks/apiHooks'
import { withdrawalResponseDefaultData } from '../../cryptoPaymentConstants'
import { usePlayerStore } from '../../../../services/store'

export const useSubmitWithdrawal = ({
  uuid,
  loading,
  setLoading,
  setWithdrawalFormSubmitError,
  setWithdrawalFormError
}) => {
  const playerStore = usePlayerStore()
  const playerUserId = playerStore.use.userId()

  const [withdrawalResponseData, setWithdrawalResponseData] = useState(withdrawalResponseDefaultData)

  const { POST } = usePost()

  const resetWithdrawalResponseData = () => setWithdrawalResponseData(withdrawalResponseDefaultData)

  const onWithdrawalFormSubmit = useCallback(() => {
    if (loading || !uuid) {
      return
    }

    setLoading(true)

    return POST(
      config.paymentsUrl +
        tokenizer(config.submitWithdrawalUrl, {
          '{userId}': playerUserId,
          '{uuid}': uuid
        })
    )
      .then(async response => {
        setLoading(false)

        if (response.errorCode) {
          setWithdrawalFormError(
            config.enableSweepstakes ? l10n.t['cryptopayment.redeem.error'] : l10n.t['cryptopayment.withdraw.error']
          )
        } else {
          setWithdrawalResponseData(response.paidCurrency)
        }
      })
      .catch(e => {
        setLoading(false)
        if (config.enableSweepstakes) {
          setWithdrawalFormSubmitError(l10n.t['cryptopayment.redeem.error'])
          console.error('[CryptoPaymentModal] Failed sending redemption request!', e)
        } else {
          setWithdrawalFormSubmitError(l10n.t['cryptopayment.withdraw.error'])
          console.error('[CryptoPaymentModal] Failed sending withdraw request!', e)
        }
      })
  }, [POST, loading, setLoading, playerUserId, setWithdrawalFormSubmitError, uuid])

  return { onWithdrawalFormSubmit, withdrawalResponseData, resetWithdrawalResponseData }
}
